// extracted by mini-css-extract-plugin
export default {"publishingConfirmationMessage":"VariantButtons__publishingConfirmationMessage-d5GgN"};